import { updateAllSelectComponent } from "../../scenegraph/select/update-select-border";

import { updateCustomSelectBorder } from "../../scenegraph/select/update-custom-select-border";

export function deletaCustomSelectRanges(state) {
    const {customSelectedRangeComponents: customSelectedRangeComponents} = state.table.scenegraph;
    customSelectedRangeComponents.forEach(((selectComp, key) => {
        selectComp.rect.delete();
    })), customSelectedRangeComponents.clear(), state.select.customSelectRanges = [];
}

export function addCustomSelectRanges(customSelectRanges, state) {
    customSelectRanges.forEach((customRange => {
        updateCustomSelectBorder(state.table.scenegraph, customRange.range, customRange.style);
    })), state.select.customSelectRanges = customSelectRanges, updateAllSelectComponent(state.table.scenegraph), 
    state.table.scenegraph.updateNextFrame();
}
//# sourceMappingURL=custom-select.js.map
